module.exports = "pegasus_template/assets/blocks/tile-layout-03.png";